<!-- Agenda: gleiche Layout-Struktur wie andere Seiten (app-content/content-wrapper) damit Kalender sichtbar ist -->
<div class="app-content content">
  <div class="content-overlay"></div>
  <div class="content-wrapper">
    <div class="content-body">
      <div class="agenda-calendar-wrapper">
        <h1 class="agenda-title">Agenda – alle Teams</h1>
        TESTER
        <!--app-order-disposition mode="agenda"></app-order-disposition-->
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
